module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/recent-votes/recent-votes-details.css
// module id = ./src/app/recent-votes/recent-votes-details.css
// module chunks = main